@if (localOnly) {
  <section class="order-1 order-md-1">
    <div class="container-md p-2">
      <hr class="d-none d-md-block" />
      <!-- Inlined from assets/img/tratt/tratt-banner.svg so the tagline can come
           from the i18n bundle and follow the active locale. Geometry is the
           designer's; keep it in step with that file. textLength pins the
           tagline to 338px, so translations cannot break the layout. -->
      <div class="text-center mb-3 p-0">
        <svg
          [attr.viewBox]="'0 0 606 218'"
          role="img"
          [attr.aria-label]="'TRATT — ' + ('branding.tagline' | transloco)"
          style="width: 100%; max-width: 606px; height: auto"
        >
          <rect width="606" height="218" fill="#1F4477"></rect>
          <g transform="translate(45 48.1) scale(1.48)">
            <path
              d="M8 4H92a6 6 0 0 1 6 6v46a6 6 0 0 1-6 6H40L22 78V62H8a6 6 0 0 1-6-6V10a6 6 0 0 1 6-6z"
              fill="#FFFFFF"
            ></path>
            <rect
              x="16"
              y="20"
              width="68"
              height="6"
              rx="3"
              fill="#1F4477"
            ></rect>
            <rect
              x="16"
              y="34"
              width="68"
              height="6"
              rx="3"
              fill="#1F4477"
            ></rect>
            <rect
              x="16"
              y="48"
              width="34"
              height="6"
              rx="3"
              fill="#E08A4E"
            ></rect>
          </g>
          <text
            x="220"
            y="108"
            [attr.textLength]="240"
            [attr.lengthAdjust]="'spacingAndGlyphs'"
            font-family="Archivo, Helvetica, Arial, sans-serif"
            font-weight="900"
            font-size="74"
            fill="#FFFFFF"
          >
            TRATT
          </text>
          <text
            x="220"
            y="140"
            [attr.textLength]="338"
            [attr.lengthAdjust]="'spacingAndGlyphs'"
            font-family="'IBM Plex Mono', ui-monospace, Menlo, monospace"
            font-size="20"
            fill="#B9C7DD"
          >
            {{ 'branding.tagline' | transloco }}
          </text>
        </svg>
      </div>
      <p style="text-align: justify">
        {{ 'login.app description' | transloco }}
      </p>
    </div>
  </section>
}

<div
  [class]="
    localOnly ? 'section order-2 order-md-2' : 'section order-2 order-md-1'
  "
  id="login"
>
  <div class="row">
    <div class="col-12" style="text-align: center">
      @if (
        settingsService.appSettings.tratt.maintenanceNotification !==
          undefined &&
        settingsService.appSettings.tratt.maintenanceNotification.active ===
          'active'
      ) {
        <tratt-maint-banner
          [serverURL]="
            settingsService.appSettings.tratt.maintenanceNotification.apiURL
          "
          [language]="appStorage.language"
        ></tratt-maint-banner>
      }
    </div>
  </div>
  @if (settingsService.appSettings.tratt.oldVersion?.url) {
    <div class="row">
      <div class="col">
        <div class="alert mb-0 py-1" style="font-size: 0.8rem">
          <i class="fa-solid fa-circle-info"></i>
          {{ 'login.old version.notice' | transloco }}
          <a [href]="settingsService.appSettings.tratt.oldVersion?.url">{{
            'login.old version.click here' | transloco
          }}</a>
        </div>
      </div>
    </div>
  }

  @if (compatibleBrowser !== false) {
    <div class="row" id="loginrow">
      @if (!localOnly) {
        <div class="col-md-6">
          <div
            class="card login-card d-flex flex-column flex-fill h-100"
            #onlinemode
          >
            <div class="card-body">
              <section class="d-flex flex-column flex-fill h-100">
                <h4>{{ 'login.online mode' | transloco }}</h4>
                <p style="text-align: center">
                  {{ 'login.online mode description' | transloco }}
                </p>
                @if (
                  !apc.tratt.login?.enabled ||
                  !apc.api?.url ||
                  !apc.api?.appToken
                ) {
                  <div
                    id="login-disabled"
                    style="
                      display: table-cell;
                      height: 100%;
                      align-content: center;
                    "
                  >
                    <i class="fa-solid fa-plug-circle-xmark fs-1"></i><br />
                    {{ 'login.online mode disabled' | transloco }}
                  </div>
                } @else if (
                  (authStoreService.serverOnline$ | async) === undefined
                    ? true
                    : (authStoreService.serverOnline$ | async)
                ) {
                  <div class="form-horizontal">
                    <tratt-authentication-component
                      [showTitle]="false"
                      (submitClick)="onOnlineSubmit($event)"
                      [authentications]="api.appProperties?.authentications"
                      [passwordReset]="api.appProperties?.reset_password"
                      [registrations]="api.appProperties?.registrations"
                    ></tratt-authentication-component>
                  </div>
                } @else {
                  <div
                    class="text-center justify-content-center d-flex flex-column flex-fill h-100 p-3 opacity-75"
                  >
                    <i
                      class="fa-solid fa-triangle-exclamation text-warning fs-1"
                    ></i>
                    <div
                      [innerHTML]="
                        'login.api not available'
                          | transloco
                            : {
                                email_link: email_link,
                              }
                      "
                    ></div>
                  </div>
                }
                <br />
              </section>
            </div>
          </div>
        </div>
      }
      <div [class]="localOnly ? 'col-12' : 'col-md-6'">
        <div class="card login-card position-relative" #localmode>
          <p
            style="
              position: absolute;
              top: 0;
              right: 0;
              text-align: right;
              margin-top: 10px;
              margin-right: 10px;
            "
          >
            <button
              type="button"
              (click)="startDemo()"
              class="btn btn-link link pointer p-0"
            >
              {{ 'login.demo' | transloco }}
            </button>
          </p>
          <div class="card-body">
            <section>
              <h4>{{ 'login.local mode' | transloco }}</h4>
              <div
                [innerHTML]="'login.local mode description' | transloco"
              ></div>
              <div>
                @if (appStorage.sessionfile !== undefined) {
                  <div
                    [innerHTML]="
                      'login.old file found'
                        | transloco
                          : { file_label: getDropzoneFileString(sessionfile) }
                    "
                    class="alert alert-warning"
                  ></div>
                }
                <div style="margin-top: 40px">
                  <ul
                    ngbNav
                    #localNav="ngbNav"
                    [(activeId)]="activeTab"
                    [destroyOnHide]="false"
                    class="nav-tabs"
                  >
                    <li [ngbNavItem]="'upload'">
                      <button ngbNavLink type="button" style="color: #000">
                        <i class="fa-solid fa-folder-open me-1"></i>
                        {{ 'login.tabs.upload' | transloco }}
                      </button>
                      <ng-template ngbNavContent>
                        <div class="pt-3">
                          <tratt-dropzone
                            #dropzone
                            [height]="'147px'"
                            [oldFiles]="sessionfile ? [sessionfile] : []"
                            [showAutoTranscribe]="true"
                          ></tratt-dropzone>
                        </div>
                      </ng-template>
                    </li>
                    <li [ngbNavItem]="'record'">
                      <button ngbNavLink type="button" style="color: #000">
                        <i class="fa-solid fa-microphone me-1"></i>
                        {{ 'login.tabs.record' | transloco }}
                      </button>
                      <ng-template ngbNavContent>
                        <div class="pt-3">
                          <tratt-recording-panel
                            (useRecording)="onUseRecording($event)"
                          ></tratt-recording-panel>
                        </div>
                      </ng-template>
                    </li>
                  </ul>
                  <div [ngbNavOutlet]="localNav"></div>
                </div>

                @if (
                  (transcription().active ||
                    transcription().error ||
                    transcription().phase === 'finalizing') &&
                  !translation().active &&
                  !translation().error
                ) {
                  <div
                    class="transcription-progress mt-3 p-3 border rounded bg-light"
                  >
                    @if (transcription().phase === 'downloading') {
                      <div>
                        <strong>{{
                          'login.auto-transcription.downloading model'
                            | transloco
                        }}</strong>
                        @if (transcription().downloadFile) {
                          <div class="text-muted small">
                            {{ transcription().downloadFile }}
                          </div>
                        }
                        @if (
                          transcription().downloadLoaded > 0 ||
                          transcription().downloadTotal > 0 ||
                          transcription().downloadExpectedBytes > 0
                        ) {
                          <div class="progress mt-1" style="height: 18px">
                            <div
                              class="progress-bar"
                              role="progressbar"
                              [style.width]="
                                (transcription().downloadLoaded /
                                  (transcription().downloadTotal ||
                                    transcription().downloadExpectedBytes)) *
                                  100 +
                                '%'
                              "
                            >
                              {{
                                (transcription().downloadLoaded /
                                  (transcription().downloadTotal ||
                                    transcription().downloadExpectedBytes)) *
                                  100 | number: '1.0-0'
                              }}%
                            </div>
                          </div>
                          <small class="text-muted">
                            {{
                              transcription().downloadLoaded / 1048576
                                | number: '1.0-0'
                            }}
                            MB /
                            {{
                              (transcription().downloadTotal ||
                                transcription().downloadExpectedBytes) / 1048576
                                | number: '1.0-0'
                            }}
                            MB
                          </small>
                        } @else {
                          <div
                            class="spinner-border spinner-border-sm ms-2"
                            role="status"
                          ></div>
                        }
                      </div>
                    } @else if (transcription().phase === 'diarizing') {
                      <div>
                        <strong>{{
                          'login.auto-transcription.diarizingLabel' | transloco
                        }}</strong>
                        <div
                          class="spinner-border spinner-border-sm ms-2 d-inline-block"
                          role="status"
                        ></div>
                        @if (
                          transcription().downloadLoaded > 0 ||
                          transcription().downloadTotal > 0
                        ) {
                          <div class="progress mt-1" style="height: 18px">
                            <div
                              class="progress-bar bg-info"
                              role="progressbar"
                              [style.width]="
                                (transcription().downloadLoaded /
                                  transcription().downloadTotal) *
                                  100 +
                                '%'
                              "
                            >
                              {{
                                (transcription().downloadLoaded /
                                  transcription().downloadTotal) *
                                  100 | number: '1.0-0'
                              }}%
                            </div>
                          </div>
                          <small class="text-muted">
                            {{
                              transcription().downloadLoaded / 1048576
                                | number: '1.0-0'
                            }}
                            MB /
                            {{
                              transcription().downloadTotal / 1048576
                                | number: '1.0-0'
                            }}
                            MB
                          </small>
                        } @else {
                          <div class="mt-1 text-muted small">
                            {{
                              'login.auto-transcription.initializing speaker segmentation'
                                | transloco
                            }}
                          </div>
                        }
                      </div>
                    } @else if (transcription().phase === 'finalizing') {
                      <div>
                        <strong>{{
                          'login.auto-transcription.transcription complete'
                            | transloco
                        }}</strong>
                        <div
                          class="spinner-border spinner-border-sm ms-2 d-inline-block"
                          role="status"
                        ></div>
                      </div>
                    } @else if (transcription().phase === 'transcribing') {
                      <div>
                        <strong>{{
                          'login.auto-transcription.transcribing audio'
                            | transloco
                        }}</strong>
                        <div
                          class="spinner-border spinner-border-sm ms-2 d-inline-block"
                          role="status"
                        ></div>
                        @if (transcription().audioDurationS > 0) {
                          <div class="progress mt-2" style="height: 14px">
                            <div
                              class="progress-bar bg-success"
                              role="progressbar"
                              [style.width]="
                                (transcription().segmentEndS /
                                  transcription().audioDurationS) *
                                  100 +
                                '%'
                              "
                            ></div>
                          </div>
                          <small class="text-muted">
                            {{ formatDuration(transcription().segmentEndS) }} /
                            {{ formatDuration(transcription().audioDurationS) }}
                            &nbsp;·&nbsp;
                            {{ 'login.auto-transcription.elapsed' | transloco }}
                            {{ formatDuration(transcriptionElapsedMs / 1000) }}
                          </small>
                        } @else {
                          <div class="mt-1 text-muted small">
                            {{ 'login.auto-transcription.elapsed' | transloco }}
                            {{ formatDuration(transcriptionElapsedMs / 1000) }}
                          </div>
                        }
                        <div class="mt-1 text-muted small">
                          {{
                            'login.auto-transcription.running locally'
                              | transloco
                          }}
                        </div>
                      </div>
                    }

                    @if (transcription().error) {
                      <div class="alert alert-danger mt-2 py-1 mb-0 small">
                        {{ transcription().error }}
                        @if (transcription().usedWebGPU) {
                          <div
                            class="mt-1"
                            [innerHTML]="
                              'login.auto-transcription.webgpu tip' | transloco
                            "
                          ></div>
                        }
                      </div>
                    }

                    <button
                      class="btn btn-sm btn-outline-secondary mt-2"
                      type="button"
                      (click)="dismissTranscriptionError()"
                    >
                      {{
                        transcription().active
                          ? ('login.auto-transcription.cancel' | transloco)
                          : ('login.auto-transcription.dismiss' | transloco)
                      }}
                    </button>

                    <small class="d-block text-muted mt-1">
                      {{ 'login.auto-transcription.model cached' | transloco }}
                    </small>

                    @if (diarizationWarning()) {
                      <div class="alert alert-warning mt-2 py-1 mb-0 small">
                        {{ diarizationWarning() }}
                      </div>
                    }
                  </div>
                }
                @if (
                  translation().active ||
                  translation().error ||
                  translation().phase === 'finalizing'
                ) {
                  <div
                    class="translation-progress mt-3 p-3 border rounded bg-light"
                  >
                    @if (translation().phase === 'downloading') {
                      <div>
                        <strong>{{
                          'login.translation.phase.downloading' | transloco
                        }}</strong>
                        @if (translation().downloadFile) {
                          <div class="text-muted small">
                            {{ translation().downloadFile }}
                          </div>
                        }
                        @if (translation().downloadTotal > 0) {
                          <div class="progress mt-1" style="height: 18px">
                            <div
                              class="progress-bar"
                              role="progressbar"
                              [style.width]="
                                (translation().downloadLoaded /
                                  translation().downloadTotal) *
                                  100 +
                                '%'
                              "
                            >
                              {{
                                (translation().downloadLoaded /
                                  translation().downloadTotal) *
                                  100 | number: '1.0-0'
                              }}%
                            </div>
                          </div>
                          <small class="text-muted">
                            {{
                              translation().downloadLoaded / 1048576
                                | number: '1.0-0'
                            }}
                            MB /
                            {{
                              translation().downloadTotal / 1048576
                                | number: '1.0-0'
                            }}
                            MB
                          </small>
                        } @else {
                          <div
                            class="spinner-border spinner-border-sm ms-2"
                            role="status"
                          ></div>
                        }
                      </div>
                    } @else if (translation().phase === 'initializing') {
                      <div>
                        <strong>{{
                          'login.translation.phase.initializing' | transloco
                        }}</strong>
                        <div
                          class="spinner-border spinner-border-sm ms-2 d-inline-block"
                          role="status"
                        ></div>
                        <div class="progress mt-2" style="height: 14px">
                          <div
                            class="progress-bar progress-bar-striped progress-bar-animated"
                            role="progressbar"
                            style="width: 100%"
                          ></div>
                        </div>
                      </div>
                    } @else if (translation().phase === 'finalizing') {
                      <div>
                        <strong>{{
                          'login.translation.phase.finalizing' | transloco
                        }}</strong>
                        <div
                          class="spinner-border spinner-border-sm ms-2 d-inline-block"
                          role="status"
                        ></div>
                      </div>
                    } @else if (translation().phase === 'translating') {
                      <div>
                        <strong>{{
                          'login.translation.phase.translating' | transloco
                        }}</strong>
                        <div
                          class="spinner-border spinner-border-sm ms-2 d-inline-block"
                          role="status"
                        ></div>
                        @if (translation().segmentTotal > 0) {
                          <div class="progress mt-2" style="height: 14px">
                            <div
                              class="progress-bar bg-success"
                              role="progressbar"
                              [style.width]="
                                (translation().segmentIndex /
                                  translation().segmentTotal) *
                                  100 +
                                '%'
                              "
                            ></div>
                          </div>
                          <small class="text-muted">
                            {{ translation().segmentIndex }} /
                            {{ translation().segmentTotal }} &nbsp;·&nbsp;
                            {{ 'login.auto-transcription.elapsed' | transloco }}
                            {{ formatDuration(translationElapsedMs / 1000) }}
                          </small>
                        }
                      </div>
                    }

                    @if (translation().error) {
                      <div class="alert alert-danger mt-2 py-1 mb-0 small">
                        {{ translation().error }}
                      </div>
                    }

                    <button
                      class="btn btn-sm btn-outline-secondary mt-2"
                      type="button"
                      (click)="dismissTranslationError()"
                    >
                      {{
                        translation().active
                          ? ('login.auto-transcription.cancel' | transloco)
                          : ('login.auto-transcription.dismiss' | transloco)
                      }}
                    </button>
                  </div>
                }
                @if (dropzone?.statistics && dropzone?.statistics?.new === 0) {
                  <button
                    (click)="onOfflineSubmit(false)"
                    [disabled]="
                      transcription().active ||
                      translation().active ||
                      (dropzone?.files?.length ?? 0) === 0 ||
                      !dropzone?.statistics ||
                      (dropzone?.statistics?.invalid ?? 0) > 0 ||
                      (dropzone?.statistics?.progress ?? 0) > 0 ||
                      (dropzone?.statistics?.waiting ?? 0) > 0
                    "
                    class="btn btn-raised btn-primary"
                    id="offline-submit"
                    type="submit"
                  >
                    {{ offlineSubmitLabelKey() | transloco }}
                  </button>
                } @else {
                  <button
                    (click)="onOfflineSubmit(true)"
                    [disabled]="
                      transcription().active ||
                      translation().active ||
                      (dropzone?.files?.length ?? 0) === 0 ||
                      !dropzone?.statistics ||
                      (dropzone?.statistics?.invalid ?? 0) > 0 ||
                      (dropzone?.statistics?.progress ?? 0) > 0 ||
                      (dropzone?.statistics?.waiting ?? 0) > 0
                    "
                    class="btn btn-raised btn-danger offline-delete-btn"
                  >
                    {{ 'transcription.new' | transloco }}
                  </button>
                }
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  } @else {
    <tratt-browser-test></tratt-browser-test>
  }
</div>
<div class="section order-3 order-md-2">
  <footer class="footer">
    <fieldset
      style="
        border: 1px solid #ccc;
        border-radius: 4px;
        padding: 0.5rem 1rem 1rem;
        background: #fff;
      "
    >
      <legend
        style="
          float: none;
          width: auto;
          font-size: 0.85rem;
          padding: 0.15rem 0.5rem;
          color: #555;
          border: 1px solid #ccc;
          border-radius: 3px;
          background: #fff;
        "
      >
        {{ 'login.funding support and development' | transloco }}
      </legend>
      <div
        class="row row-cols-auto justify-content-center align-items-center g-3"
      >
        <div class="col">
          <img
            alt="VISP — Visible Speech"
            class="logo"
            src="./assets/img/visp_slogan_sv.svg"
          />
        </div>
        <div class="col">
          <a href="https://www.sweclarin.se/" target="_blank">
            <img
              alt="SweCLARIN"
              class="logo"
              src="./assets/img/sweclarin_logo.png"
            />
          </a>
        </div>
        <div class="col">
          <a href="https://www.umu.se/en/humlab/" target="_blank">
            <img
              alt="Humlab – Umeå University"
              class="logo"
              src="./assets/img/humlab_logo_left_en.png"
            />
          </a>
        </div>
        <div class="col">
          <a href="http://www.en.phonetik.uni-muenchen.de/" target="_blank">
            <img
              alt="IPS LMU Munich"
              class="logo"
              src="./assets/img/ipsx60.png"
            />
          </a>
        </div>
        <div class="col">
          <a
            href="https://www.bas.uni-muenchen.de/Bas/BasHomeeng.html"
            target="_blank"
          >
            <img alt="BAS" class="logo" src="./assets/img/bas.png" />
          </a>
        </div>
        <div class="col">
          <a href="https://www.clarin-d.net/en/" target="_blank">
            <img alt="Clarin-D" class="logo" src="./assets/img/clarin-d.png" />
          </a>
        </div>
      </div>
    </fieldset>
  </footer>
</div>
<div class="section order-4 order-md-3">
  <footer class="footer">
    <fieldset
      style="
        border: 1px solid #ccc;
        border-radius: 4px;
        padding: 0.5rem 1rem 1rem;
        background: #fff;
      "
    >
      <legend
        style="
          float: none;
          width: auto;
          font-size: 0.85rem;
          padding: 0.15rem 0.5rem;
          color: #555;
          border: 1px solid #ccc;
          border-radius: 3px;
          background: #fff;
        "
      >
        {{ 'login.groups that developed the language models' | transloco }}
      </legend>
      <div
        class="row row-cols-auto justify-content-center align-items-center g-3"
      >
        <div class="col">
          <a href="https://github.com/Helsinki-NLP" target="_blank">
            <img
              alt="Language Technology at the University of Helsinki"
              class="logo"
              src="./assets/img/helsinki-nlp.png"
            />
          </a>
        </div>
        <div class="col">
          <a href="https://huggingface.co/Finnish-NLP" target="_blank">
            <img
              alt="Finnish-NLP"
              class="logo"
              src="./assets/img/finnish-nlp.png"
            />
          </a>
        </div>
        <div class="col">
          <a href="https://ai.nb.no/" target="_blank">
            <img
              alt="AI-lab at National Library of Norway"
              class="logo"
              src="./assets/img/nb-ai-lab.png"
            />
          </a>
        </div>
        <div class="col">
          <a
            href="https://www.kb.se/eng/research-collaboration/kblab.html"
            target="_blank"
          >
            <img
              alt="KBLab – National Library of Sweden"
              class="logo"
              src="./assets/img/kblab.svg"
            />
          </a>
        </div>
        <div class="col">
          <a href="https://huggingface.co/openai" target="_blank">
            <img alt="OpenAI" class="logo" src="./assets/img/openai.png" />
          </a>
        </div>
        <div class="col">
          <a href="https://github.com/pyannote/pyannote-audio" target="_blank">
            <img alt="pyannote" class="logo" src="./assets/img/pyannote.webp" />
          </a>
        </div>
      </div>
    </fieldset>
  </footer>
</div>
